import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as Styled from './icon-button.styles';
export const IconButton = ({ className, disabled, href, icon: Icon, innerRef, loading, onClick, size = 'medium', sizeConfined, sizeWide, to, type, ...props }) => {
    const iconSize = size === 'small' ? 18 : 24;
    const commonProps = {
        $size: size,
        $sizeConfined: sizeConfined,
        $sizeWide: sizeWide,
        'aria-label': loading ? 'loading' : null,
        'data-xds': 'IconButton',
        className,
        disabled: disabled || loading,
        onClick,
        ref: innerRef,
    };
    const buttonContent = (_jsxs(React.Fragment, { children: [!loading && Icon && (_jsx(Styled.IconContainer, { "$iconSize": iconSize, children: _jsx(Icon, { width: iconSize, height: iconSize }) })), loading && (_jsx(Styled.Loading, { "$size": size, "$sizeConfined": sizeConfined, "$sizeWide": sizeWide, "aria-hidden": "true" }))] }));
    return (_jsx(React.Fragment, { children: to || href ? (_jsx(Styled.RouterIconButton, { ...(to && { to }), ...(href && { href }), ...commonProps, ...props, children: buttonContent })) : (_jsx(Styled.IconButton, { type: type, ...commonProps, ...props, children: buttonContent })) }));
};
IconButton.displayName = 'IconButton';
//# sourceMappingURL=icon-button.js.map